import { Injectable } from '@angular/core';
import { ProjectService, WmHttpService } from '@wms/app/services';


@Injectable({
  providedIn: 'root'
})
export class DeploymentApiService {
  TARGET = 'Deployment';
  API_META: any = {
    setupInfo: {
      url: '/license/admin/setup-info',
      method: 'GET',
    embedModeAPI: true,
    spinnerInfo: {
        showSpinner: false
      }
    },
    getFirstPhaseInfo: {
      url: '/deployment-cloud/rest/app-pipeline-phases?projectId=:projectId',
      method: 'GET',
      spinnerInfo: {
        showSpinner: false
      },
      embedModeAPI: true
    },
    pullDeployStatus: {
      url: '/deployment-cloud/rest/app-pipeline-phases/:pipelinePhaseId/deployment',
      method: 'GET',
      spinnerInfo: {
        showSpinner: false
      }
    },
    configureAndDeploy: {
      url: '/deployment-cloud/rest/app-pipeline-phases/one-click-deployment',
      method: 'POST',
      spinnerInfo: {
        showSpinner: false
      }
    },
    deployFirstPhase: {
      url: '/deployment-cloud/rest/app-pipeline-phases/:pipelinePhaseId/deployment',
      method: 'POST',
      spinnerInfo: {
        showSpinner: false
      }
    }
  };
  envType: string;

  constructor(private wmHttpService: WmHttpService,
    private projectService: ProjectService
  ) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
  }

  getEnvType() {
    if (this.envType) {
      return Promise.resolve(this.envType);
    }
    return this.getSetupInfo().then((setupInfo: any) => {
      this.envType = setupInfo.envType;
      return this.envType;
    }).catch((error: any) => {
      console.log(error);
      return Promise.reject(error);
    });
  }

  getSetupInfo() {
    return this.wmHttpService.execute({
      target: this.TARGET,
      action: 'setupInfo',
    }) as Promise<any>;
  }

  getFirstPhaseInfo() {
    return this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getFirstPhaseInfo',
      pathParams: {
        projectId: this.projectService.getProjectEdnDetails().id,
      },
    }) as Promise<any>;
  }

  pullDeployStatus(params: any, pipelinePhaseParams: any) {
    return this.wmHttpService.execute({
      target: this.TARGET,
      action: 'pullDeployStatus',
      data: params,
      pathParams: {
        ...pipelinePhaseParams
      },
    }) as Promise<any>;
  }

  configureAndDeploy(configureParams: any) {
    return this.wmHttpService.execute({
      target: this.TARGET,
      action: 'configureAndDeploy',
      data: configureParams,
    }) as Promise<any>;
  }

  deployFirstPhase(params: any, pipelinePhaseParams: any) {
    return this.wmHttpService.execute({
      target: this.TARGET,
      action: 'deployFirstPhase',
      data: params,
      pathParams: {
        ...pipelinePhaseParams
      },
    }) as Promise<any>;
  }
}
